/**
 * Service pour appeler les Firebase Cloud Functions
 * Remplace les appels API vers le backend Python (Railway)
 */

import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { app } from '../firebase/config';

// Initialiser Firebase Functions (région Europe)
const functions = getFunctions(app, 'europe-west1');

// En développement, utiliser l'émulateur local (décommenter si besoin)
// if (process.env.NODE_ENV === 'development') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }

// ============================================
// PUSH NOTIFICATIONS
// ============================================


/**
 * Envoyer une notification à un segment
 */
export const sendBulkNotification = async (segment, title, body, data = {}) => {
  try {
    const fn = httpsCallable(functions, 'sendBulkNotification');
    const result = await fn({ segment, title, body, data });
    return result.data;
  } catch (error) {
    console.error('Erreur sendBulkNotification:', error);
    throw error;
  }
};

// ============================================
// IMAGES
// ============================================

/**
 * Supprimer le fond d'une image
 */
export const removeBackground = async (imageUrl) => {
  try {
    const fn = httpsCallable(functions, 'removeBackground');
    const result = await fn({ image_url: imageUrl });
    return result.data;
  } catch (error) {
    console.error('Erreur removeBackground:', error);
    throw error;
  }
};

// ============================================
// EMAILS
// ============================================

/**
 * Envoyer un email de confirmation de commande
 */
export const sendOrderConfirmation = async (order, customerEmail, customerName) => {
  try {
    const fn = httpsCallable(functions, 'sendOrderConfirmation');
    const result = await fn({ order, customer_email: customerEmail, customer_name: customerName });
    return result.data;
  } catch (error) {
    console.error('Erreur sendOrderConfirmation:', error);
    throw error;
  }
};

/**
 * Envoyer un email à une liste d'adresses arbitraire (ex: contacts Innovorder).
 * dryRun true (def) = compte seulement ; testEmail = aperçu ; sinon envoi réel.
 */
export const sendEmailToList = async ({ emails = [], subject, message, dryRun = true, testEmail = '', source = 'innovorder' }) => {
  const fn = httpsCallable(functions, 'sendEmailToList');
  const result = await fn({ emails, subject, message, dryRun, testEmail, source });
  return result.data;
};

// Export par défaut
/**
 * Statistiques des favoris synchronisés (admin/super_admin, contrôlé côté serveur).
 * @param {{start_date: string, end_date: string, top?: number}} params dates AAAA-MM-JJ (Paris)
 */
export const getFavoritesStats = async (params) => {
  const fn = httpsCallable(functions, 'getFavoritesStats');
  const result = await fn(params);
  return result.data;
};

export default {
  sendBulkNotification,
  removeBackground,
  sendOrderConfirmation,
  sendEmailToList
};
